import React from 'react';
import { FormattedMessage, FormattedDate } from 'react-intl';
import classnames from 'classnames';
import dayjs from 'dayjs';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const EtdFromColumn = ColumnTree.defineNode(
  'etd-from',
  ({ sortDirection, sortColumn, setSort }) => ({
    title: (
      <div>
        <a
          href="#etd-from"
          className={classnames('icon-sort', 'sortem', {
            [sortDirection]: sortColumn === 'etd-from',
          })}
          onClick={() => setSort('etd-from')}
        >
          <FormattedMessage
            id="marketplace-table-heading-etdfrom"
            description="Table heading, ETD from time"
            defaultMessage="ETD From"
          />
        </a>
      </div>
    ),
    key: 'etd-from',
    className: 'col-etd-from',
    render: (text, record) => {
      if (record.quarteretd) {
        return {
          children: (
            <div className="td-content">
              <span className="nowrap">{record.quarteretd}</span>
            </div>
          ),
          props: { colSpan: 2 },
        };
      }
      return (
        <div className="td-content">
          <span className="tiny-label">
            <FormattedMessage
              id="marketplace-table-cell-etdfrom"
              defaultMessage="ETD from"
            />
          </span>
          <span className="nowrap">
            <FormattedDate
              value={dayjs(record.etd.from).toDate()}
              day="numeric"
              month="short"
              year="numeric"
            />
          </span>
        </div>
      );
    },
  })
);
